<template>
  <el-dialog
    :close-on-click-modal="false"
    title="批量审核"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  orderReceiptBatchApprove,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      baseForm: {
        form: [
          {
            label: '审核结果',
            value: 'result',
            type: 'radio',
            default: 1,
            onChange: () => {
              this.handleResultChange();
            },
            options: [
              {
                label: '通过',
                value: 1,
              },
              {
                label: '驳回',
                value: 2,
              },
            ],
          },
          {
            label: '驳回内容',
            value: 'rejectContent',
            type: 'checkbox',
            hide: false,
            options: [
              {
                label: '驳回回单',
                value: 'loadState',
              },
              {
                label: '驳回合同',
                value: 'reciveState',
              },
            ],
          },
          {
            label: '备注',
            value: 'verifyDesc',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: { // 表单验证规则
          result: [ // 审核结果
            { required: true, message: '请选择审核结果', trigger: 'blur' },
          ],
          rejectContent: [ // 结果
            { required: true, message: '请选择结果', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleResultChange () {
      const result = this.$refs.baseForm.getVal('result');
      if (result === 1) {
        this.$refs.baseForm.setVal('rejectContent', []);
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: result === 1,
        names: ['rejectContent'],
      });
    },


    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.baseForm.reset();
        if (item) { // 修改
          this.type = 'edit';
          this.originData = item;
        }
        this.handleResultChange();
      });
    },

    customFormPost () {
      this.$refs.baseForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const orderIdsStr = this.originData.map((item) => item.orderId);
      const res = await orderReceiptBatchApprove({
        auditCode: 300008,
        verifyDesc: form.verifyDesc,
        result: form.result,
        receipt: form.rejectContent.indexOf('reciveState') !== -1,
        reciveState: form.rejectContent.indexOf('reciveState') !== -1,
        load: form.rejectContent.indexOf('loadState') !== -1,
        loadState: form.rejectContent.indexOf('loadState') !== -1,
        orderIdsStr: orderIdsStr.join(','),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        // this.$message({
        //   type: 'success',
        //   message: '保存成功',
        // });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
